import { isFunction } from '../../../../common/base';
import { findNodeByClass } from './util'; // QQ微信登录框

var mQQWxFrame = {
  top: null,
  $loginFrame: null,
  init: function init(callback, top) {
    var self = this;
    self.top = top;

    if (!self.$loginFrame) {
      var tpl = '<div class="milo_login_type_choose">\
                <p class="milo_ltc_hd"><i>请选择您要登录的账号</i><span class="milo_ltc_close">&times;</span></p>\
                <div class="milo_ltc_bd">\
                    <a  href="javascript:void(0)" class="milo_ltc_qq"><b>QQ登录</b></a>\
                    <a  href="javascript:void(0)" class="milo_ltc_wx"><b>微信登录</b></a>\
                </div>\
            </div>';
      self.$loginFrame = document.createElement('div');
      self.$loginFrame.classList.add('milo_login_mobile_qqwx');
      self.$loginFrame.innerHTML = tpl;
      document.getElementsByTagName('body')[0].appendChild(self.$loginFrame);
      var styleStr = '.milo_login_mobile_qqwx { width: 100%; height: 100%; z-index: 100; position: fixed; left: 0px; top: 0px; background-color: rgba(0, 0, 0, 0.5); }\
            .milo_login_type_choose { position: absolute; left: 50%; top: 50%; margin-left: -160px; margin-top: -115px; width: 320px; }\
            .milo_login_type_choose * { margin: 0px; padding: 0px; }\
            .milo_ltc_hd { position: relative; height: 40px; font: 400 14px/40px Arial; color: #fff; text-indent: 15px; border-radius: 3px 3px 0 0; background-color: #4BABFC; background-image: linear-gradient(90deg, #80BDFF 0%, #1098F8 100%) }\
            .milo_ltc_hd i{font-style:normal}\
            .milo_ltc_hd span { position: absolute; right: 7px; top: 5px; font: 400 30px/30px Arial; }\
            .milo_ltc_bd { text-align: center; padding: 40px 0px 60px; background-color: #fefeff; border: 1px solid #7DBCFF; border-top: none; border-radius: 0 0 3px 3px; }\
            .milo_ltc_bd a { position: relative; display: inline-block; zoom: 1; #display: inline; width: 80px; height: 80px; border-radius: 50%; margin: 0px 15px; background-image: url(https://game.gtimg.cn/images/xylz/milo_ltc_img.png); background-repeat: no-repeat; background-color: #f5f5f5; }\
            .milo_ltc_bd a b { position: absolute; left: 0px; bottom: -25px; width: 100%; text-align: center; color: #666; font: 400 14px/21px Arial; }\
            .milo_ltc_qq { background-position: 20px 18px; }\
            .milo_ltc_wx { background-position: -165px 18px; }';
      var styleEl = document.createElement('style');
      styleEl.setAttribute('type', 'text/css');
      styleEl.innerHTML = styleStr;
      document.getElementsByTagName('head')[0].appendChild(styleEl); // 绑定相关事件

      self.bindEvents();
      isFunction(callback) && callback();
    } else {
      isFunction(callback) && callback();
    }
  },
  oWXParams: {},
  oQQParams: {},
  fBeforeQQLogin: null,
  fBeforeWXLogin: null,
  loginByQQ: null,
  loginByWX: null,
  show: function show() {
    this.$loginFrame.style.display = 'block';
  },
  hide: function hide() {
    this.$loginFrame.style.display = 'none';
  },
  bindEvents: function bindEvents() {
    var self = this; // qq登录

    var qqTab = findNodeByClass(self.$loginFrame, 'milo_ltc_qq');
    var wxTab = findNodeByClass(self.$loginFrame, 'milo_ltc_wx');
    var closeBtn = findNodeByClass(self.$loginFrame, 'milo_ltc_close');
    qqTab.addEventListener('click', function () {
      if (isFunction(self.fBeforeQQLogin) && false === self.fBeforeQQLogin()) {
        return;
      }

      isFunction(self.loginByQQ) && self.loginByQQ(self.oQQParams);
    }, false);
    wxTab.addEventListener('click', function () {
      if (isFunction(self.fBeforeWXLogin) && false === self.fBeforeWXLogin()) {
        return;
      }

      isFunction(self.loginByWX) && self.loginByWX(self.oQQParams);
    }, false); // 关闭

    closeBtn.addEventListener('click', function () {
      self.hide();
    }, false);
  }
};
export default mQQWxFrame;